export type AppLocale = 'ko' | 'en' | 'ja';

export const SUPPORTED_LOCALES: AppLocale[] = ['ko', 'en', 'ja'];
export const DEFAULT_LOCALE: AppLocale = 'ko';

export const DISPLAY_TRANSLATIONS: Record<Exclude<AppLocale, 'ko'>, Record<string, string>> = {
  en: {
    '암호는 영문, 숫자 [0-9, a-z, A-Z] 만 허용합니다.': 'Passwords can only contain letters and numbers [0-9, a-z, A-Z].',
    '닫기': 'Close',
    '선택': 'Select',
    '취소': 'Cancel',
    '설정': 'Settings',
    '확인': 'OK',
    '삭제': 'Delete',
    '적용': 'Apply',
    '검색': 'Search',
    '추가': 'Add',
    '제외': 'Exclude',
    '전송': 'Send',
    '전환': 'Switch',
    '전송 중...': 'Sending...',
    '처리중...': 'Processing...',
    '불러오는 중...': 'Loading...',
    '불러오는 중입니다...': 'Loading...',
    '파일 로딩중...': 'Loading file...',
    '다시 시도': 'Try again',
    '다시 시도해 주세요.': 'Please try again.',
    '나가기': 'Leave',
    '재입장': 'Rejoin',
    '더보기': 'More',
    '이전': 'Previous',
    '다음': 'Next',
    '전체': 'All',
    '전체보기': 'View all',
    '전체화면': 'Full screen',
    '전체화면 보기': 'View full screen',
    '접기': 'Collapse',
    '펼치기': 'Expand',
    '복사': 'Copy',
    '복사됨!': 'Copied!',
    '다운로드': 'Download',
    '내보내기': 'Remove',
    '복원': 'Restore',
    '종료': 'End',
    '사용': 'Use',
    '미사용': 'Do not use',
    '없음': 'None',
    '있음': 'Available',
    '기타': 'Other',
    '정보': 'Info',
    '상세정보': 'Details',
    '메뉴': 'Menu',
    '이름': 'Name',
    '종류': 'Type',
    '크기': 'Size',
    '시간': 'Time',
    '분': 'min',
    '초': 'sec',
    '시간&nbsp;': 'hours&nbsp;',
    '분 진행중': 'minutes in progress',
    '화상대화 사용시간': 'Video call duration',
    '명': 'people',
    '명)': ' people)',
    '개': 'items',
    '쪽': 'pages',
    '나': 'Me',
    '(나)': '(me)',
    ' (나)': ' (me)',
    '님': '',
    '님이 참석을 요청하였습니다.': ' requested to join.',
    '님 외': ' and others',
    '이 있어요!': ' are waiting!',
    '외': 'others',
    '알 수 없음': 'Unknown',
    '알 수 없는 사용자': 'Unknown user',
    '알 수 없는 디바이스': 'Unknown device',
    '사용자': 'User',
    '익명': 'Anonymous',
    '익명 사용자': 'Anonymous user',
    '이름없음': 'No name',
    '프로필 이미지': 'Profile image',
    '국기이미지': 'Flag image',
    '음량아이콘': 'Volume icon',

    '한국어': 'Korean',
    '영어': 'English',
    '일본어': 'Japanese',
    '러시아어': 'Russian',

    '회의': 'Meeting',
    '회의실': 'Meeting room',
    '회의 ID': 'Meeting ID',
    '회의ID': 'Meeting ID',
    '회의 링크': 'Meeting link',
    '회의명': 'Meeting name',
    '회의명 :': 'Meeting name:',
    '회의제목': 'Meeting title',
    '회의정보': 'Meeting info',
    '회의정보 복사': 'Copy meeting info',
    '회의 정보 복사': 'Copy meeting info',
    '회의 정보가 복사되었습니다.': 'Meeting info has been copied.',
    '회의 ID가 복사되었습니다.': 'Meeting ID has been copied.',
    '회의 암호를 입력해주세요.': 'Please enter the meeting password.',
    '회의 암호가 맞지 않습니다.': 'The meeting password is incorrect.',
    '암호': 'Password',
    '암호를 입력해주세요.': 'Please enter a password.',
    '참가': 'Join',
    '회의 참여하기': 'Join meeting',
    '회의 참여 요청': 'Join request',
    '회의 참여 요청이 있어요!': 'Join requests are waiting!',
    '회의 나가기': 'Leave meeting',
    '회의를 나가시겠습니까?': 'Do you want to leave the meeting?',
    '모두에게 회의 종료': 'End meeting for everyone',
    '회의가 종료되었습니다.': 'The meeting has ended.',
    '종료된 회의입니다.': 'This meeting has ended.',
    '회의 연결 종료': 'Meeting disconnected',
    '회의 연결에 실패했습니다': 'Failed to connect to the meeting',
    '회의 연결 중 오류가 발생했습니다.': 'An error occurred while connecting to the meeting.',
    '회의를 종료하고 있습니다...': 'Ending the meeting...',
    '회의 퇴장': 'Leave meeting',
    '회의 설정': 'Meeting settings',
    '회의 설정 변경': 'Change meeting settings',
    '회의 설정이 변경되었습니다.': 'Meeting settings have been changed.',
    '반가워요. {{name}}님!': 'Welcome, {{name}}!',
    '참석하시기전에 나눈대화들을 정리해보았어요.': "Here's a summary of the conversation before you joined.",
    '오늘 회의를 시작하기 전,': "Before today's meeting begins,",
    '지난번 논의되었던 핵심내용을 가볍게 훑어보세요!': 'take a quick look at the key points from the previous meeting!',
    '회의 설정 변경에 실패했습니다.': 'Failed to change meeting settings.',
    '회의 설정 정보를 불러오는 중입니다...': 'Loading meeting settings...',
    '회의 설명': 'Meeting description',
    '회의 주제를 입력해주세요.': 'Please enter a meeting topic.',
    '회의 키워드': 'Meeting keywords',
    '회의명으로 검색하세요.': 'Search by meeting name.',
    '회의일자 :': 'Meeting date:',
    '참석자 :': 'Participants:',
    '회의메모·요약': 'Meeting memo and summary',
    '회의 기록 보러가기': 'View meeting records',
    '회의 기록': 'Meeting records',
    '회의 중 공유된 내용이나 대화 기록을 다시 확인하고,': 'Review shared content and conversation history from the meeting,',
    '로 회의 내용을 요약하여': 'to summarize the meeting content with',
    '핵심 정보를 빠르게 파악해보세요!': 'and quickly understand the key information!',
    '회의 참석자': 'Meeting participants',
    '회의 참석하는 모든 사람이 편집할 수 있습니다': 'Everyone in the meeting can edit.',
    '회의 초대 링크 또는 암호를 통해 회의에 참가할 수 있습니다.': 'People can join the meeting using the invite link or password.',
    '초대받지 않은 인원도 회의 링크나 회의 ID를 통해 회의에 참가할 수 있습니다.': 'People who were not invited can also join using the meeting link or meeting ID.',
    '공개 회의': 'Public meeting',
    '비공개 회의': 'Private meeting',
    '공개여부': 'Visibility',
    '연결된 회의': 'Linked meeting',
    '개설자': 'Host',
    '시작일시': 'Start date and time',
    '회의설정 변경하기': 'Change meeting settings',
    '개설되지 않은 화상회의 방입니다.': 'This video meeting room has not been created.',
    '주소가 잘못되었거나 개설자가 취소 또는 삭제한 화상회의입니다.': 'The address is incorrect, or the meeting was canceled or deleted by the host.',
    '참여자에게 회의주소를 다시 확인해 주시기 바랍니다.': 'Please ask the participant to check the meeting address again.',
    '화상회의가 삭제되었거나': 'The video meeting has been deleted,',
    '마스터가 이 회의를 종료했습니다.': 'or the master has ended this meeting.',
    '참석 인원이 초과하였습니다.': 'The participant limit has been exceeded.',
    '회의에 참석 가능한 인원은 최대 50명입니다.': 'Up to 50 people can join this meeting.',
    '마스터에게 문의해주세요.': 'Please contact the master.',
    '참석 요청 거절': 'Join request denied',
    '마스터가 참석 요청을 거절했습니다.': 'The master denied your join request.',
    '다른 회의를 개설하거나 마스터에게 문의하세요.': 'Create another meeting or contact the master.',
    'WEHAGO 메인으로': 'Go to WEHAGO main',

    '참석자': 'Participants',
    '참석 예정자': 'Expected participants',
    '참석순': 'Join order',
    '가나다순': 'Alphabetical',
    '참여자': 'Participant',
    '참여자 리스트': 'Participant list',
    '참여자 없음': 'No participants',
    '참여자목록 접기/펴기': 'Collapse/expand participant list',
    '참석자 제어': 'Participant controls',
    '참석자 내보내기': 'Remove participant',
    '화상회의 참여자': 'Video meeting participants',
    '온라인': 'Online',
    '오프라인': 'Offline',
    '이메일 미등록': 'Email not registered',
    '전화번호 미등록': 'Phone number not registered',
    '마스터': 'Master',
    '마스터 권한 부여': 'Grant master permission',
    '마스터 권한 해제': 'Remove master permission',
    '마스터 권한은 회원에게만 부여할 수 있습니다.': 'Master permission can only be granted to members.',
    '마스터 승인': 'Master approval',
    '마스터가 참석 요청을 승인한 사용자만 회의에 참가할 수 있습니다.': 'Only users approved by the master can join the meeting.',
    '마스터의 승인을 기다리고 있습니다.': 'Waiting for master approval.',
    '마스터가 참석을 승인할 때까지 잠시만 기다려주세요.': 'Please wait until the master approves your request.',
    '참석 알림을 전송하였습니다.': 'The join notification has been sent.',
    '참여 알림 전송': 'Send join notification',
    '참여 알림을 재전송했습니다.': 'The join notification has been resent.',
    '알림 재전송에 실패했습니다.': 'Failed to resend the notification.',
    '재전송': 'Resend',
    '재전송 횟수를 초과했습니다.': 'The resend limit has been exceeded.',
    '해당 참석자는 이미 참석 중입니다.': 'This participant is already in the meeting.',
    '이미 참석한 사용자입니다.': 'This user has already joined.',
    '이미 회의에 참석하였습니다.': 'Already joined the meeting.',
    '이미 초대된 사용자입니다.': 'This user has already been invited.',
    '종료된 회의에는 초대할 수 없습니다.': 'You cannot invite people to an ended meeting.',
    '최대 참석자 수를 초과하였습니다.': 'The maximum number of participants has been exceeded.',
    '초대 권한이 없습니다.': 'You do not have invite permission.',
    '회의방을 찾을 수 없습니다.': 'The meeting room could not be found.',

    '초대': 'Invite',
    '초대하기': 'Invite',
    '초대 대상자가 없습니다.': 'There are no invitees.',
    '초대 중 오류가 발생했습니다.': 'An error occurred while inviting.',
    '조직도': 'Organization',
    '연락처': 'Contacts',
    '외부참여자': 'External participants',
    '진행중인 회의': 'Ongoing meeting',
    '이름 또는 소속으로 검색하세요.': 'Search by name or organization.',
    '이름 또는 연락처로 검색하세요.': 'Search by name or contact.',
    '찾으시는 참석자가 없어요.': 'No matching participants found.',
    '이름을 다시 확인해주세요.': 'Please check the name again.',
    '이메일을 입력하여 참석자에게': 'Enter an email address to send',
    '초대 메일을 보내보세요!': 'an invite email to the participant.',
    '이메일 주소를 입력해주세요': 'Please enter an email address.',
    '이메일 주소를 입력해주세요.': 'Please enter an email address.',
    '이메일을 입력해주세요.': 'Please enter an email.',
    '올바른 이메일 형식이 아닙니다.': 'The email format is invalid.',
    '올바르지 않은 이메일 주소입니다.': 'The email address is invalid.',
    '이미 추가된 이메일입니다.': 'This email has already been added.',
    '이메일 초대': 'Email invite',
    '추가된 내역이 없습니다.': 'No items have been added.',
    '최근 초대한 이메일 주소': 'Recently invited email addresses',
    '추가한 이메일 주소': 'Added email addresses',
    '아래의 URL과 참여코드를 복사하여 공유하면': 'Copy and share the URL and join code below',
    '외부사용자를 화상회의 방에 초대할 수 있습니다.': 'to invite external users to the video meeting room.',
    '화상회의 외부공유': 'External video meeting share',
    '화상회의방 외부공유': 'External video meeting room share',
    '화상회의 URL': 'Video meeting URL',
    'URL 복사': 'Copy URL',
    '참여코드': 'Join code',
    '요청 메시지': 'Request message',
    '최대 200자': 'Up to 200 characters',
    '초대 이메일을 전송했습니다.': 'Invite email has been sent.',
    '전송 중 오류가 발생했습니다.': 'An error occurred while sending.',

    '채팅': 'Chat',
    '대화기록': 'Conversation history',
    '대화 기록하기': 'Record conversation',
    '대화기록 닫기': 'Close conversation history',
    '메시지를 입력해주세요.': 'Please enter a message.',
    '음성 메모 / 통역': 'Voice memo / interpretation',
    '음성 텍스트 변환': 'Speech-to-text',
    '음성인식': 'Speech recognition',
    '음성인식 설정': 'Speech recognition settings',
    '음성인식 언어 설정': 'Speech recognition language settings',
    '음성인식 활성화': 'Enable speech recognition',
    '음성인식활성화': 'Enable speech recognition',
    '음성 인식을 활성화할까요?': 'Do you want to enable speech recognition?',
    '음성 인식 중 — 자막에 표시됩니다': 'Recognizing speech - shown in captions',
    '인식 언어': 'Recognition language',
    '음성인식을 사용하는 참석자가 없습니다.': 'No participants are using speech recognition.',
    '음성인식을 사용하여 대화를 기록해보세요!': 'Use speech recognition to record the conversation.',
    '님의 발언이 기록됩니다.': ' will be recorded.',
    '님의 발언이 더이상 기록되지 않습니다.': ' will no longer be recorded.',

    '자막/번역': 'Captions/Translation',
    '자막/번역설정': 'Caption/translation settings',
    '자막/번역 언어': 'Caption/translation language',
    '자막/번역언어': 'Caption/translation language',
    '자막 표시': 'Show captions',
    '자막 표시 불가': 'Captions unavailable',
    '자막 히스토리': 'Caption history',
    '자막 글꼴 크기': 'Caption font size',
    '화면에 자막을 표시합니다.': 'Show captions on the screen.',
    '화면에 자막을 표시하지 않습니다.': 'Do not show captions on the screen.',
    '화면에 번역을 표시합니다.': 'Show translations on the screen.',
    '화면에 번역을 표시하지 않습니다.': 'Do not show translations on the screen.',
    '자막을 보려면 본인 또는 다른 참석자가\n음성 인식을 활성화해야 합니다.': 'To view captions, you or another participant must\nenable speech recognition.',
    '내 음성 인식이 꺼져있어 다른 참석자에게는\n내 발언이 자막으로 보이지 않습니다.': 'Your speech recognition is off, so other participants\nwill not see your speech as captions.',
    '음성인식을 설정한 참여자들의 발언을': 'Speech from participants with speech recognition enabled',
    '자막으로 제공합니다.': 'is provided as captions.',
    '번역 자막': 'Translated captions',
    '발언 내용을 원하는 언어로': 'Speech is translated in real time',
    '실시간 번역하여 자막으로 제공합니다.': 'into the language you choose and shown as captions.',
    '실시간 자막이 시작되었습니다.': 'Live captions have started.',
    '실시간 자막이 종료되었습니다.': 'Live captions have ended.',
    '실시간 번역이 시작되었습니다.': 'Live translation has started.',
    '실시간 번역이 종료되었습니다.': 'Live translation has ended.',
    'Credit이 모두 소진되어 번역이 중지되었습니다.': 'All credits have been used, so translation has stopped.',
    'Credit이 부족하여 번역 기능을 사용할 수 없습니다.': 'Translation is unavailable because credits are insufficient.',
    '크레딧이 부족합니다.': 'Insufficient credits.',
    '크레딧 조회에 실패했습니다. 다시 시도해주세요.': 'Failed to retrieve credits. Please try again.',
    '추가 크레딧 구매하기': 'Buy additional credits',
    '크레딧 추가 구매는 회사 관리자에게 문의해주세요.': 'Contact your company administrator to purchase additional credits.',
    '번역회의': 'Translation meeting',
    '우리회사 크레딧 사용': 'Use our company credits',
    '각 회사의 크레딧 사용': 'Use each company\'s credits',
    '외부 참석자들도 회사 크레딧으로 번역 사용을 허용합니다.': 'Allow external participants to use company credits for translation.',
    '외부 참석자들은 각 회사의 크레딧으로 번역을 사용합니다.': 'External participants use translation with their own company credits.',
    '크레딧을 사용하여 실시간 번역을 제공합니다. 크레딧이 부족할 경우 기능이 제한될 수 있습니다.': 'Live translation uses credits. Some features may be limited if credits are insufficient.',
    '*자막/번역 기능은 음성인식을 설정한 참여자들의 발언에만': '*Caption/translation applies only to speech from participants who enabled speech recognition',
    '기능을 제공하며 실시간 번역은 Credit이 차감됩니다.': 'and live translation consumes credits.',

    '마이크': 'Microphone',
    '카메라': 'Camera',
    '스피커': 'Speaker',
    '오디오': 'Audio',
    '비디오': 'Video',
    '마이크 선택': 'Select microphone',
    '카메라 선택': 'Select camera',
    '스피커 선택': 'Select speaker',
    '마이크 끄기': 'Turn microphone off',
    '마이크 켜기': 'Turn microphone on',
    '카메라 끄기': 'Turn camera off',
    '카메라 켜기': 'Turn camera on',
    '마이크 켜기 요청': 'Request microphone on',
    '카메라 켜기 요청': 'Request camera on',
    '마이크 켜기 요청을 보냈습니다.': 'Microphone-on request has been sent.',
    '카메라 켜기 요청을 보냈습니다.': 'Camera-on request has been sent.',
    '스피커를 선택하세요': 'Select a speaker',
    '마이크를 선택하세요': 'Select a microphone',
    '카메라를 선택하세요': 'Select a camera',
    '사용 가능한 스피커 없음': 'No available speakers',
    '사용 가능한 마이크 없음': 'No available microphones',
    '사용 가능한 카메라 없음': 'No available cameras',
    '카메라가 없거나 선택되지 않았습니다.': 'No camera is available or selected.',
    '디바이스 없음': 'No device',
    '스피커 테스트': 'Speaker test',
    '영상 설정': 'Video settings',
    '거울 모드(좌우반전)': 'Mirror mode (flip horizontally)',
    '좌우반전': 'Flip horizontally',
    '좌우 반전': 'Flip horizontally',
    '회전': 'Rotate',
    '스페이스바를 누르고있는동안': 'While holding the Space key',
    '마이크가 켜집니다.': 'the microphone turns on.',
    'Space키를 길게 눌러 내 음소거를 일시적으로 해제': 'Hold Space to temporarily unmute yourself',
    '회의에 참가할 때 내 마이크 음소거': 'Mute my microphone when joining a meeting',
    '마이크 또는 카메라 권한을 허용해주세요.': 'Please allow microphone or camera permission.',
    '마이크 및 카메라 권한이 필요합니다.': 'Microphone and camera permission is required.',
    '브라우저 설정(상단 주소 표시줄 왼쪽의 아이콘)에서': 'In browser settings (the icon on the left side of the address bar),',
    '마스터가 마이크 사용을 요청하였습니다.': 'The master requested that you turn on your microphone.',
    '마스터가 카메라 사용을 요청하였습니다.': 'The master requested that you turn on your camera.',
    '마스터에 의해 마이크가 꺼졌습니다.': 'Your microphone was turned off by the master.',
    '마스터에 의해 카메라가 꺼졌습니다.': 'Your camera was turned off by the master.',
    '마스터에 의해 회의에서 내보내졌습니다.': 'You were removed from the meeting by the master.',
    '모두 마이크 끄기': 'Turn all microphones off',
    '모두 마이크 켜기 요청': 'Request all microphones on',
    '모두 카메라 끄기': 'Turn all cameras off',
    '모두 카메라 켜기 요청': 'Request all cameras on',
    '모든 참석자의 마이크가 이미 꺼져있습니다.': 'All participants\' microphones are already off.',
    '모든 참석자의 마이크를 껐습니다.': 'All participants\' microphones have been turned off.',
    '모든 참석자의 카메라가 이미 꺼져있습니다.': 'All participants\' cameras are already off.',
    '모든 참석자의 카메라를 껐습니다.': 'All participants\' cameras have been turned off.',
    '소리 켜기': 'Turn sound on',
    '음소거': 'Mute',
    '음소거 해제': 'Unmute',

    '화면 공유': 'Screen share',
    '화면공유': 'Screen share',
    '화면 공유 중': 'Screen sharing',
    '화면 공유중': 'Screen sharing',
    '화면 공유 중지': 'Stop screen sharing',
    '공유': 'Share',
    '공유 중지': 'Stop sharing',
    '공유취소': 'Cancel sharing',
    '공유취소 버튼을 눌러주세요': 'press the Cancel sharing button.',
    '다른 참여자가 이미 공유 중입니다.': 'Another participant is already sharing.',
    '다른 사용자의 공유가 끝난 후': 'After the other user stops sharing,',
    '이미 문서공유가 진행중입니다.': 'Document sharing is already in progress.',
    '이미 스케치모드가 진행중입니다.': 'Sketch mode is already in progress.',
    '이미 문서공유 또는 스케치가 진행중입니다.': 'Document sharing or sketch mode is already in progress.',
    '화면·문서 공유 중': 'Screen/document sharing',
    '나의 공유 화면': 'My shared screen',
    '화면 고정': 'Pin screen',
    '화면 고정 해제': 'Unpin screen',
    '고정': 'Pin',
    '고정 해제': 'Unpin',
    '고정했습니다.': 'Pinned.',
    '고정 해제했습니다.': 'Unpinned.',
    '나에게만 화면 고정': 'Pin for me only',
    '모두에게 화면 고정': 'Pin for everyone',
    '마스터가 고정한 화면입니다.': 'This screen was pinned by the master.',
    '마스터가 화면을 고정하여 변경할 수 없습니다.': 'The master pinned the screen, so it cannot be changed.',
    '고정된 화면을 해제한 후 다시 시도해주세요.': 'Unpin the pinned screen and try again.',
    '고정된 화면으로 돌아가기': 'Return to pinned screen',
    '화면은 최대 ${...}개까지 고정가능합니다.': 'You can pin up to ${...} screens.',
    '화면이 고정되었습니다. ${...}/${...}': 'Screen pinned. ${...}/${...}',
    '화면 고정이 해제되었습니다. ${...}/${...}': 'Screen unpinned. ${...}/${...}',
    '일반화면': 'Standard view',
    '분할화면': 'Split view',
    '그리드뷰': 'Grid view',
    '사이드뷰': 'Side view',
    '발표자뷰': 'Presenter view',
    '자동정렬': 'Auto sort',
    '자동 정렬': 'Auto sort',
    '발언자 우선 정렬': 'Prioritize speaker',
    '참여자명 정렬': 'Sort by participant name',
    '보기': 'View',
    '정렬 기준': 'Sort by',
    '화면 자동 전환': 'Auto screen switching',
    '연결 품질:': 'Connection quality:',
    '수신 해상도:': 'Receive resolution:',
    '네트워크 상태 :': 'Network status:',
    '좋음': 'Good',
    '보통': 'Normal',
    '나쁨': 'Poor',
    '네트워크가 불안정하여 연결이 종료되었습니다.': 'The connection ended because the network is unstable.',
    '네트워크 상태 확인 후 회의에 다시 참석해 주세요.': 'Check your network status and rejoin the meeting.',
    '네트워크 상태가 불안정합니다. 화질이나 음성이 일시적으로 끊길 수 있습니다.': 'Your network is unstable. Video or audio may be interrupted temporarily.',
    '네트워크 상태가 좋지 않습니다. Wi-Fi 또는 유선 연결 상태를 확인해 주세요.': 'Your network connection is poor. Please check your Wi-Fi or wired connection.',
    '회의 연결이 불안정합니다. 네트워크 상태를 확인해 주세요.': 'The meeting connection is unstable. Please check your network status.',
    '마이크에서 큰 소음이나 하울링이 감지됩니다. 스피커 볼륨을 낮추거나 이어폰을 사용해 주세요.': 'Loud noise or audio feedback is detected from your microphone. Lower your speaker volume or use earphones.',

    '문서 공유': 'Document sharing',
    '문서공유': 'Document sharing',
    '문서 공유 중': 'Document sharing',
    '문서공유 모드': 'Document sharing mode',
    '문서 공유 종료': 'End document sharing',
    '문서공유 종료': 'End document sharing',
    '문서공유를 종료하시겠습니까?': 'Do you want to end document sharing?',
    '문서 공유 중 오류가 발생했습니다.': 'An error occurred during document sharing.',
    '문서 공유에 실패했습니다. 지원하지 않는 파일 형식이거나\n용량이 초과되었을 수 있습니다.': 'Document sharing failed. The file type may not be supported\nor the size may exceed the limit.',
    '문서 이전': 'Previous document',
    '문서 다음': 'Next document',
    '문서리스트 닫기': 'Close document list',
    '문서를 변환 중입니다...': 'Converting document...',
    '문서를 불러오는 중입니다...': 'Loading document...',
    '문서를 미리볼 수 없습니다.': 'Cannot preview the document.',
    '문서 변환에 실패했습니다. 잠시 후 다시 시도해주세요.': 'Document conversion failed. Please try again later.',
    '문서 변환 중 오류가 발생했습니다.': 'An error occurred while converting the document.',
    '문서 변환에 실패하였습니다.\n잠시 후 다시 시도해 주세요.': 'Document conversion failed.\nPlease try again later.',
    '문서 자동 요약 및 일정 관리 기능 도입': 'Introduce automatic document summarization and schedule management',
    '파일 선택': 'Select file',
    '파일선택': 'Select file',
    '파일 목록을 불러올 수 없습니다.': 'Cannot load the file list.',
    '파일 목록이 업데이트되었습니다. 총 ': 'The file list has been updated. Total ',
    '파일 목록이 업데이트되었습니다. 총': 'The file list has been updated. Total',
    '개의 파일이 있습니다.': ' files are available.',
    '파일 변환 중입니다. 잠시 후 다시 시도해주세요.': 'The file is being converted. Please try again later.',
    '파일이 저장되었습니다.': 'File has been saved.',
    '파일을 다운로드하고 있습니다.(': 'Downloading file (',
    '파일명': 'File name',
    '파일뷰어': 'File viewer',
    '페이지를 불러올 수 없습니다.': 'Cannot load the page.',
    '이미지를 미리볼 수 없습니다.': 'Cannot preview the image.',
    '이미지에 문제가 발생하여 미리볼 수 없습니다.': 'Cannot preview the image because an issue occurred.',
    '너비 맞춤': 'Fit width',
    '높이 맞춤': 'Fit height',
    '실제 사이즈': 'Actual size',
    '작성 날짜': 'Created date',
    '업로드 날짜': 'Upload date',
    '업로드한 날짜': 'Uploaded date',
    '수정된 날짜': 'Modified date',
    '수정한 날짜': 'Modified date',
    '업로더': 'Uploader',
    '수정한 사람': 'Modified by',
    '일반 정보': 'General information',
    'WE드라이브': 'WE Drive',
    'WE 드라이브': 'WE Drive',
    'WE드라이브 회의자료 등록 실패:': 'Failed to register WE Drive meeting material:',
    'WE드라이브에서 파일찾기': 'Find files in WE Drive',
    'WE드라이브 정보를 불러올 수 없습니다.\n로그인 상태를 확인해주세요.': 'Cannot load WE Drive information.\nPlease check your login status.',
    '지원하지 않는 파일 형식입니다. (${...})': 'Unsupported file type. (${...})',
    '지원 형식: hwp, doc(x), xls(x), ppt(x), bmp, gif, jpg, png, pdf': 'Supported formats: hwp, doc(x), xls(x), ppt(x), bmp, gif, jpg, png, pdf',
    '공유 파일 용량 초과\n공유 가능한 파일 용량을 초과하였습니다.\n20MB 이하의  파일을 선택해주세요.': 'Shared file size exceeded.\nThe file exceeds the shareable size.\nPlease select a file of 20 MB or less.',
    '공유 파일 용량 초과\n공유 가능한 파일 용량을 초과하였습니다.\n20MB 이하의 파일을 선택해주세요.': 'Shared file size exceeded.\nThe file exceeds the shareable size.\nPlease select a file of 20 MB or less.',
    '검색어를 입력해주세요.': 'Please enter a search term.',
    '표시할 내용이 없습니다.': 'No content to display.',
    '회의자료': 'Meeting materials',
    '회의자료 등록 실패:': 'Failed to register meeting material:',
    '회의 자료를 불러오는 중입니다...': 'Loading meeting materials...',
    '회의 자료를 삭제할까요?': 'Delete meeting materials?',
    '회의자료 첨부': 'Attach meeting material',
    '첨부파일 선택': 'Select attachment',
    '전체선택': 'Select all',
    '이전 회의 자료': 'Previous meeting materials',
    '등록된 회의 자료가 없습니다.': 'There are no registered meeting materials.',
    '필요한 자료를 업로드하여 다른 참석자와 공유해보세요!': 'Upload materials you need and share them with other participants.',
    '삭제된 파일은 복구할 수 없으며\n다른 참석자들에게 더 이상 노출되지 않습니다.': 'Deleted files cannot be restored\nand will no longer be shown to other participants.',
    '삭제된 파일은 복구할 수 없으며\n다른 참석자들에게 더 이상 노출되지 않습니다.\n*다른 사람이 첨부한 파일을 제외하고 삭제합니다.': 'Deleted files cannot be restored\nand will no longer be shown to other participants.\n*Files attached by other people are excluded from deletion.',
    '다운로드가 취소되었습니다.': 'Download has been canceled.',

    '스케치 모드': 'Sketch mode',
    '스케치 종료': 'End sketch',
    '스케치 공유': 'Sketch sharing',
    '스케치모드 공유 중': 'Sketch mode sharing',
    '스케치 화면을': 'Use the sketch screen',
    '더 넓게 활용 해보세요': 'more widely',
    '다양한 그리기 도구를 이용해': 'Use various drawing tools',
    '화면에 스케치를 할 수 있어요!': 'to sketch on the screen!',
    '스케치 공유 중에도': 'Even while sketch sharing is active,',
    '다른 참석자들을 확인 할 수 있어요': 'you can check other participants.',
    '작성중인 스케치 화면을 캡쳐해보세요!': 'Capture the sketch screen you are working on!',
    '캡쳐된 이미지는 회의기록에서도 확인': 'Captured images can also be checked in meeting records',
    '할 수 있어요': 'later.',
    '스케치를 종료 하려면': 'To end sketching,',
    '현재 스케치 화면이 캡쳐되었습니다.': 'The current sketch screen has been captured.',
    '스케치 캡쳐가 저장되었습니다.': 'Sketch capture has been saved.',
    '캡쳐 실패:': 'Capture failed:',
    '캡쳐': 'Capture',
    '스케치 화면을 ‘캡쳐’ 해서 저장해 보세요!': 'Capture the sketch screen and save it!',
    '회의기록에 저장할 스케치 화면을 ‘캡쳐’ 해보세요!': 'Capture the sketch screen to save it in meeting records!',
    '화이트보드': 'Whiteboard',
    '회의 스케치': 'Meeting sketch',
    '공동 편집': 'Collaborative editing',
    '공동 편집이 종료되었어요.': 'Collaborative editing has ended.',
    '공동 편집이 활성화 되었어요. 함께 스케치해보세요!': 'Collaborative editing is active. Sketch together!',
    '권한 변경에 실패했습니다. 다시 시도해 주세요.': 'Failed to change permission. Please try again.',
    '편집 권한': 'Edit permission',
    '공유자외에 다른 참석자는 보기만 가능합니다.': 'Participants other than the sharer can only view.',
    '공유모드 선택': 'Select sharing mode',
    '뷰어': 'Viewer',
    '사이드바 가리기': 'Hide sidebar',
    '썸네일': 'Thumbnail',
    '크게보기': 'Enlarge',
    '눈금': 'Grid',
    '눈금 없음': 'No grid',
    '배경색': 'Background color',
    '그리기': 'Draw',
    '펜': 'Pen',
    '펜툴': 'Pen tool',
    '지우개': 'Eraser',
    '도형': 'Shape',
    '도형 선택': 'Select shape',
    '네모': 'Rectangle',
    '원': 'Circle',
    '마름모': 'Diamond',
    '다이아몬드': 'Diamond',
    '선': 'Line',
    '화살표': 'Arrow',
    '텍스트': 'Text',
    '실행취소': 'Undo',
    '재실행': 'Redo',
    '다시실행': 'Redo',
    '이전으로 복귀': 'Go back',
    '축소': 'Zoom out',
    '확대': 'Zoom in',
    '전체 지우기': 'Clear all',
    '흰색': 'White',
    '회색': 'Gray',
    '파란색': 'Blue',
    '노란색': 'Yellow',
    '격자 1': 'Grid 1',
    '격자 2': 'Grid 2',
    '검정': 'Black',
    '빨강': 'Red',
    '파랑': 'Blue',
    '초록': 'Green',
    '노랑': 'Yellow',
    '보라': 'Purple',

    '배경': 'Background',
    '가상배경': 'Virtual background',
    '가상 배경': 'Virtual background',
    '가상배경 설정': 'Virtual background settings',
    '화상회의 배경설정': 'Video meeting background settings',
    '배경 및 효과를 설정해주세요.': 'Set a background and effects.',
    '배경 선택': 'Select background',
    '배경 이미지': 'Background image',
    '배경없음': 'No background',
    '효과 및 블러 없음': 'No effect or blur',
    '흐리게': 'Blur',
    '블러 30%': 'Blur 30%',
    '블러 80%': 'Blur 80%',
    '이미지 추가': 'Add image',
    '사용자 지정 이미지': 'Custom image',
    '사용자 설정 시뮬레이션 화면': 'Custom settings simulation screen',
    '은은한': 'Soft',
    '은은한 배경': 'Soft background',
    '스터디카페': 'Study cafe',
    '카페': 'Cafe',
    '사무실': 'Office',
    '오피스': 'Office',
    '석양': 'Sunset',
    '노을': 'Sunset',
    '해변': 'Beach',
    '시티뷰': 'City view',
    '도시': 'City',
    '기하학적인': 'Geometric',
    '기하학': 'Geometric',
    '현대적인': 'Modern',
    '모던': 'Modern',
    '오로라': 'Aurora',
    '아바타 1': 'Avatar 1',
    '아바타 2': 'Avatar 2',
    '아바타 3': 'Avatar 3',
    '5MB이하의 이미지 형식만 가능합니다.': 'Only image files up to 5 MB are allowed.',
    '최대 ${...}개까지 추가가 가능합니다.': 'You can add up to ${...} items.',
    '추가하기': 'Add',
    '다음에': 'Later',

    '발언권 요청': 'Floor request',
    '발언권 요청 (': 'Floor requests (',
    '발언권 요청 중입니다...': 'Requesting the floor...',
    '발언권을 요청하였습니다.': 'requested the floor.',
    '발언권이 승인되었습니다.': 'Floor request approved.',
    '발언권 모드': 'Floor mode',
    '발언권 모드 해제': 'Turn off floor mode',
    '발언권 모드가 활성화되었습니다.': 'Floor mode has been enabled.',
    '발언 요청': 'Request floor',
    '발언 종료': 'End floor',
    '요청 취소': 'Cancel request',
    '전체 수락': 'Accept all',
    '전체 거부': 'Reject all',
    '전체 거절': 'Reject all',
    '전체 승인': 'Approve all',
    '수락': 'Accept',
    '거절': 'Reject',
    '거부': 'Reject',
    '승인': 'Approve',

    '리액션': 'Reaction',
    '이모티콘': 'Emoticon',
    '캐릭터': 'Character',
    '최근': 'Recent',
    '좋아요': 'Like',
    '박수': 'Clap',
    '하트눈': 'Heart eyes',
    '불꽃': 'Fire',
    '축하': 'Celebrate',
    '하트': 'Heart',
    '100점': '100 points',
    '위대리': 'Wi Daeri',
    '고과장': 'Go Gwajang',
    '하사원': 'Ha Sawon',
    '다하쥐': 'Dahajwi',
    '퉁카': 'Tungka',

    '영상녹화': 'Video recording',
    '회의녹화': 'Meeting recording',
    '회의 녹화': 'Meeting recording',
    '녹화 중지': 'Stop recording',
    '회의를 기록하고 저장할 수 있습니다.': 'You can record and save the meeting.',
    '녹화된 영상은 회의 기록에서 조회가능합니다.': 'Recorded videos can be viewed in meeting records.',
    '화면 녹화': 'Screen recording',

    '테스트': 'Test',
    '현재 상태': 'Current status',
    '현재 뷰': 'Current view',
    '참여자 수': 'Participant count',
    '(원격': '(remote',
    '+ 본인)': '+ me)',
    '적용 정책': 'Applied policy',
    '오버라이드': 'Override',
    '그리드뷰 정책 편집': 'Edit grid view policy',
    '구간 추가': 'Add range',
    '조건': 'Condition',
    '해상도': 'Resolution',
    '메인': 'Main',
    '서브': 'Sub',
    '뷰 모드': 'View mode',
    '대상': 'Target',
    '기본값 복원': 'Restore defaults',
    '자동 (정책 기본값)': 'Auto (policy default)',
    '그리드 뷰에서 한 화면에 표시할 최대 사용자 수를 선택하세요': 'Select the maximum number of users to show on one screen in grid view.',
    '참여자 수 구간별 수신 해상도를 설정합니다. 구간은 오름차순으로 자동 정렬됩니다.': 'Set the receive resolution by participant-count range. Ranges are automatically sorted in ascending order.',
    '발표자·사이드뷰의 수신 해상도를 강제로 고정합니다. &quot;자동&quot;은 기본 정책 값을 따릅니다.': 'Force the receive resolution for presenter/side view. &quot;Auto&quot; follows the default policy.',
    '발표자/사이드뷰 해상도 오버라이드': 'Presenter/side view resolution override',

    '검색어 입력': 'Enter search term',
    '두 글자 이상 입력해주세요.': 'Please enter at least two characters.',
    '내용입력': 'Enter content',
    '키워드 추가': 'Add keyword',
    '키워드를 입력하고 Enter를 눌러주세요.': 'Enter a keyword and press Enter.',
    '선택안함': 'None selected',
    '모든 참석자에게 이전 회의 내용 공유': 'Share previous meeting content with all participants',
    '지난 회의 참석자에게만 이전 회의 내용 공유': 'Share previous meeting content only with previous meeting participants',
    '암호가 있는 사용자만 회의에 참가할 수 있습니다.': 'Only users with the password can join the meeting.',
    '발표자 자동전환': 'Presenter auto-switch',

    '화상회의에서 사용할 이름을 설정해 주세요.': 'Set the name to use in the video meeting.',
    '참석자 명': 'Participant name',
    '사용자의 음성을 텍스트로 변환하여': 'Convert the user\'s speech to text',
    '자막과 번역을 제공하고, 회의 기록을 확인할 수 있습니다.': 'to provide captions and translations, and to view meeting records.',
    '사용자의 음성을 텍스트로 변환하여 자막과 번역을 제공하고, 회의': 'Converts user speech to text to provide captions and translations, and meeting',
    '기록을 확인할 수 있습니다.': 'records can be checked.',
    '*화상회의 중 음성인식은 실시간 분석 및 대화기록에만 사용되며 회의 종료 후  음성 데이터는 저장되지 않습니다.': '*Speech recognition during video meetings is used only for real-time analysis and conversation records. Voice data is not stored after the meeting ends.',
    '*화상회의 중 음성인식은 실시간 분석 및 대화기록에만 사용되며 회의 종료 후 음성 데이터는 저장되지 않습니다.': '*Speech recognition during video meetings is used only for real-time analysis and conversation records. Voice data is not stored after the meeting ends.',
    'ESC 키를 누르면 전체화면 모드가 종료됩니다.': 'Press ESC to exit full-screen mode.',
    '화상회의 잠시 후 시작': 'The video meeting will start soon',
    '화상회의 시작 ${...} 전': '${...} before video meeting starts',
    '이 회의는': 'This meeting is scheduled to start at',
    '에 시작 예정입니다.': '.',
    '화상회의가 시작됩니다.': 'The video meeting will begin.',
    '약 ${...}분': 'about ${...} minutes',
    '약 ${...}시간': 'about ${...} hours',
    '약 ${...}시간 ${...}분': 'about ${...} hours ${...} minutes',

    '월': 'Mon',
    '화': 'Tue',
    '수': 'Wed',
    '목': 'Thu',
    '금': 'Fri',
    '토': 'Sat',
    '일': 'Sun',
    '월요일': 'Monday',
    '화요일': 'Tuesday',
    '수요일': 'Wednesday',
    '목요일': 'Thursday',
    '금요일': 'Friday',
    '토요일': 'Saturday',
    '일요일': 'Sunday',
    '오전': 'AM',
    '오후': 'PM',

    '필요한 데이터 및 보안 문제 검토': 'Review required data and security issues',
    '현재 사용중인 업무 플랫폼과 AI 연동 가능 여부': 'Whether AI integration is possible with the current work platform',
    '기대효과 및 실무 적용 가능성 분석': 'Analyze expected effects and practical applicability',
    '업무 효율성 향상 및 반복 작업 감소': 'Improve work efficiency and reduce repetitive tasks',
    '1. 주요 논의 내용': '1. Main discussion points',
    '2. 결정 사항 및 해야할 일': '2. Decisions and action items',
    'AI 기반 업무 자동화 방안': 'AI-based work automation plan',
    'AI 챗봇을 활용한 사내정보 검색 기능 추가': 'Add internal information search using an AI chatbot',
    '고객 대응 AI 시스템 도입 검토 (FAQ 자동응답, 상담 지원)': 'Review introducing a customer-response AI system (FAQ auto-replies, consultation support)',
    '고객 응대 속도 개선 및 직원 업무 부담 감소': 'Improve customer response speed and reduce employee workload',
    '기술적 검토 필요 사항': 'Items requiring technical review',
    '기술검토 : 개발팀에서 AI 연동 가능성 검토 (담당 : 홍길동)': 'Technical review: development team to review AI integration feasibility (owner: Hong Gil-dong)',
    'ONE AI 더 알아보기': 'Learn more about ONE AI',

    '@jitsi/excalidraw 패키지가 설치되지 않았습니다.': '@jitsi/excalidraw package is not installed.',
    'state 값을 찾을 수 없습니다.': 'Could not find the state value.',
    'lib-jitsi-meet 라이브러리를 불러올 수 없습니다.': 'Could not load the lib-jitsi-meet library.',
    'LUXDialog: DialogProvider가 마운트되지 않았습니다.': 'LUXDialog: DialogProvider is not mounted.',
  },
  ja: {
    '암호는 영문, 숫자 [0-9, a-z, A-Z] 만 허용합니다.': 'パスワードは半角英数字 [0-9, a-z, A-Z] のみ使用可能です。',
    '닫기': '閉じる',
    '선택': '選択',
    '취소': 'キャンセル',
    '설정': '設定',
    '확인': '確認',
    '삭제': '削除',
    '적용': '適用',
    '검색': '検索',
    '추가': '追加',
    '제외': '除外',
    '전송': '送信',
    '전환': '切替',
    '전송 중...': '送信中...',
    '처리중...': '処理中...',
    '불러오는 중...': '読み込み中...',
    '불러오는 중입니다...': '読み込み中...',
    '파일 로딩중...': 'ファイルを読み込み中...',
    '다시 시도': '再試行',
    '다시 시도해 주세요.': 'もう一度お試しください。',
    '나가기': '退出',
    '재입장': '再入室',
    '더보기': 'もっと見る',
    '이전': '前へ',
    '다음': '次へ',
    '전체': 'すべて',
    '전체보기': 'すべて表示',
    '전체화면': '全画面',
    '전체화면 보기': '全画面表示',
    '접기': '折りたたむ',
    '펼치기': '展開',
    '복사': 'コピー',
    '복사됨!': 'コピーしました！',
    '다운로드': 'ダウンロード',
    '내보내기': '退出させる',
    '복원': '復元',
    '종료': '終了',
    '사용': '使用',
    '미사용': '未使用',
    '없음': 'なし',
    '있음': 'あり',
    '기타': 'その他',
    '정보': '情報',
    '상세정보': '詳細情報',
    '메뉴': 'メニュー',
    '이름': '名前',
    '종류': '種類',
    '크기': 'サイズ',
    '시간': '時間',
    '분': '分',
    '초': '秒',
    '시간&nbsp;': '時間&nbsp;',
    '분 진행중': '分進行中',
    '화상대화 사용시간': 'ビデオ通話利用時間',
    '명': '名',
    '명)': '名)',
    '개': '件',
    '쪽': 'ページ',
    '나': '自分',
    '(나)': '(自分)',
    ' (나)': ' (自分)',
    '님': 'さん',
    '님이 참석을 요청하였습니다.': 'さんが参加をリクエストしました。',
    '님 외': 'さんほか',
    '이 있어요!': 'があります！',
    '외': 'ほか',
    '알 수 없음': '不明',
    '알 수 없는 사용자': '不明なユーザー',
    '알 수 없는 디바이스': '不明なデバイス',
    '사용자': 'ユーザー',
    '익명': '匿名',
    '익명 사용자': '匿名ユーザー',
    '이름없음': '名前なし',
    '프로필 이미지': 'プロフィール画像',
    '국기이미지': '国旗画像',
    '음량아이콘': '音量アイコン',

    '한국어': '韓国語',
    '영어': '英語',
    '일본어': '日本語',
    '러시아어': 'ロシア語',

    '회의': '会議',
    '회의실': '会議室',
    '회의 ID': '会議ID',
    '회의ID': '会議ID',
    '회의 링크': '会議リンク',
    '회의명': '会議名',
    '회의명 :': '会議名:',
    '회의제목': '会議タイトル',
    '회의정보': '会議情報',
    '회의정보 복사': '会議情報をコピー',
    '회의 정보 복사': '会議情報をコピー',
    '회의 정보가 복사되었습니다.': '会議情報をコピーしました。',
    '회의 ID가 복사되었습니다.': '会議IDをコピーしました。',
    '회의 암호를 입력해주세요.': '会議パスワードを入力してください。',
    '회의 암호가 맞지 않습니다.': '会議パスワードが正しくありません。',
    '암호': 'パスワード',
    '암호를 입력해주세요.': 'パスワードを入力してください。',
    '참가': '参加',
    '회의 참여하기': '会議に参加',
    '회의 참여 요청': '参加リクエスト',
    '회의 참여 요청이 있어요!': '参加リクエストがあります！',
    '회의 나가기': '会議から退出',
    '회의를 나가시겠습니까?': '会議から退出しますか？',
    '모두에게 회의 종료': '全員の会議を終了',
    '회의가 종료되었습니다.': '会議が終了しました。',
    '종료된 회의입니다.': '終了した会議です。',
    '회의 연결 종료': '会議接続終了',
    '회의 연결에 실패했습니다': '会議への接続に失敗しました',
    '회의 연결 중 오류가 발생했습니다.': '会議接続中にエラーが発生しました。',
    '회의를 종료하고 있습니다...': '会議を終了しています...',
    '회의 퇴장': '会議退出',
    '회의 설정': '会議設定',
    '회의 설정 변경': '会議設定を変更',
    '회의 설정이 변경되었습니다.': '会議設定が変更されました。',
    '반가워요. {{name}}님!': 'ようこそ、{{name}}さん！',
    '참석하시기전에 나눈대화들을 정리해보았어요.': '参加される前の会話をまとめました。',
    '오늘 회의를 시작하기 전,': '今日の会議を始める前に、',
    '지난번 논의되었던 핵심내용을 가볍게 훑어보세요!': '前回議論された要点をさっと確認してみましょう！',
    '회의 설정 변경에 실패했습니다.': '会議設定の変更に失敗しました。',
    '회의 설정 정보를 불러오는 중입니다...': '会議設定情報を読み込み中...',
    '회의 설명': '会議説明',
    '회의 주제를 입력해주세요.': '会議の件名を入力してください。',
    '회의 키워드': '会議キーワード',
    '회의명으로 검색하세요.': '会議名で検索してください。',
    '회의일자 :': '会議日:',
    '참석자 :': '参加者:',
    '회의메모·요약': '会議メモ・要約',
    '회의 기록 보러가기': '会議記録を見る',
    '회의 중 공유된 내용이나 대화 기록을 다시 확인하고,': '会議中に共有された内容や会話履歴を確認し、',
    '로 회의 내용을 요약하여': 'で会議内容を要約して',
    '핵심 정보를 빠르게 파악해보세요!': '重要情報をすばやく把握しましょう！',
    '회의 참석자': '会議参加者',
    '회의 참석하는 모든 사람이 편집할 수 있습니다': '会議に参加している全員が編集できます。',
    '회의 초대 링크 또는 암호를 통해 회의에 참가할 수 있습니다.': '会議招待リンクまたはパスワードで会議に参加できます。',
    '초대받지 않은 인원도 회의 링크나 회의 ID를 통해 회의에 참가할 수 있습니다.': '招待されていない人も会議リンクまたは会議IDで参加できます。',
    '공개 회의': '公開会議',
    '비공개 회의': '非公開会議',
    '공개여부': '公開設定',
    '연결된 회의': '連携された会議',
    '개설자': '作成者',
    '시작일시': '開始日時',
    '회의설정 변경하기': '会議設定を変更',
    '개설되지 않은 화상회의 방입니다.': '作成されていないビデオ会議室です。',
    '주소가 잘못되었거나 개설자가 취소 또는 삭제한 화상회의입니다.': 'アドレスが間違っているか、作成者がキャンセルまたは削除した会議です。',
    '참여자에게 회의주소를 다시 확인해 주시기 바랍니다.': '参加者に会議アドレスを再確認するよう案内してください。',
    '화상회의가 삭제되었거나': 'ビデオ会議が削除されたか、',
    '마스터가 이 회의를 종료했습니다.': 'マスターがこの会議を終了しました。',
    '참석 인원이 초과하였습니다.': '参加人数を超過しました。',
    '회의에 참석 가능한 인원은 최대 50명입니다.': 'この会議に参加できる人数は最大50名です。',
    '마스터에게 문의해주세요.': 'マスターにお問い合わせください。',
    '참석 요청 거절': '参加リクエスト拒否',
    '마스터가 참석 요청을 거절했습니다.': 'マスターが参加リクエストを拒否しました。',
    '다른 회의를 개설하거나 마스터에게 문의하세요.': '別の会議を作成するか、マスターにお問い合わせください。',
    'WEHAGO 메인으로': 'WEHAGOメインへ',

    '참석자': '参加者',
    '참석 예정자': '参加予定者',
    '참석순': '参加順',
    '가나다순': '五十音順',
    '참여자': '参加者',
    '참여자 리스트': '参加者リスト',
    '참여자 없음': '参加者なし',
    '참여자목록 접기/펴기': '参加者一覧を折りたたむ/展開',
    '참석자 제어': '参加者制御',
    '참석자 내보내기': '参加者を退出させる',
    '화상회의 참여자': 'ビデオ会議参加者',
    '온라인': 'オンライン',
    '오프라인': 'オフライン',
    '이메일 미등록': 'メール未登録',
    '전화번호 미등록': '電話番号未登録',
    '마스터': 'マスター',
    '마스터 권한 부여': 'マスター権限を付与',
    '마스터 권한 해제': 'マスター権限を解除',
    '마스터 권한은 회원에게만 부여할 수 있습니다.': 'マスター権限は会員にのみ付与できます。',
    '마스터 승인': 'マスター承認',
    '마스터가 참석 요청을 승인한 사용자만 회의에 참가할 수 있습니다.': 'マスターが参加を承認したユーザーのみ会議に参加できます。',
    '마스터의 승인을 기다리고 있습니다.': 'マスターの承認を待っています。',
    '마스터가 참석을 승인할 때까지 잠시만 기다려주세요.': 'マスターが参加を承認するまでしばらくお待ちください。',
    '참석 알림을 전송하였습니다.': '参加通知を送信しました。',
    '참여 알림 전송': '参加通知を送信',
    '참여 알림을 재전송했습니다.': '参加通知を再送しました。',
    '알림 재전송에 실패했습니다.': '通知の再送に失敗しました。',
    '재전송': '再送',
    '재전송 횟수를 초과했습니다.': '再送回数を超過しました。',
    '해당 참석자는 이미 참석 중입니다.': 'この参加者はすでに参加中です。',
    '이미 참석한 사용자입니다.': 'すでに参加しているユーザーです。',
    '이미 회의에 참석하였습니다.': 'すでに会議に参加しています。',
    '이미 초대된 사용자입니다.': 'すでに招待されたユーザーです。',
    '종료된 회의에는 초대할 수 없습니다.': '終了した会議には招待できません。',
    '최대 참석자 수를 초과하였습니다.': '最大参加者数を超過しました。',
    '초대 권한이 없습니다.': '招待権限がありません。',
    '회의방을 찾을 수 없습니다.': '会議室が見つかりません。',

    '초대': '招待',
    '초대하기': '招待する',
    '초대 대상자가 없습니다.': '招待対象者がいません。',
    '초대 중 오류가 발생했습니다.': '招待中にエラーが発生しました。',
    '조직도': '組織図',
    '연락처': '連絡先',
    '외부참여자': '外部参加者',
    '진행중인 회의': '進行中の会議',
    '이름 또는 소속으로 검색하세요.': '名前または所属で検索してください。',
    '이름 또는 연락처로 검색하세요.': '名前または連絡先で検索してください。',
    '찾으시는 참석자가 없어요.': '該当する参加者がいません。',
    '이름을 다시 확인해주세요.': '名前をもう一度確認してください。',
    '이메일을 입력하여 참석자에게': 'メールアドレスを入力して参加者に',
    '초대 메일을 보내보세요!': '招待メールを送ってみましょう！',
    '이메일 주소를 입력해주세요': 'メールアドレスを入力してください。',
    '이메일 주소를 입력해주세요.': 'メールアドレスを入力してください。',
    '이메일을 입력해주세요.': 'メールを入力してください。',
    '올바른 이메일 형식이 아닙니다.': 'メール形式が正しくありません。',
    '올바르지 않은 이메일 주소입니다.': '正しくないメールアドレスです。',
    '이미 추가된 이메일입니다.': 'すでに追加されたメールです。',
    '이메일 초대': 'メール招待',
    '추가된 내역이 없습니다.': '追加された履歴がありません。',
    '최근 초대한 이메일 주소': '最近招待したメールアドレス',
    '추가한 이메일 주소': '追加したメールアドレス',
    '아래의 URL과 참여코드를 복사하여 공유하면': '下記のURLと参加コードをコピーして共有すると、',
    '외부사용자를 화상회의 방에 초대할 수 있습니다.': '外部ユーザーをビデオ会議室に招待できます。',
    '화상회의 외부공유': 'ビデオ会議の外部共有',
    '화상회의방 외부공유': 'ビデオ会議室の外部共有',
    '화상회의 URL': 'ビデオ会議URL',
    'URL 복사': 'URLをコピー',
    '참여코드': '参加コード',
    '요청 메시지': 'リクエストメッセージ',
    '최대 200자': '最大200文字',
    '초대 이메일을 전송했습니다.': '招待メールを送信しました。',
    '전송 중 오류가 발생했습니다.': '送信中にエラーが発生しました。',

    '채팅': 'チャット',
    '대화기록': '会話履歴',
    '대화 기록하기': '会話を記録',
    '대화기록 닫기': '会話履歴を閉じる',
    '메시지를 입력해주세요.': 'メッセージを入力してください。',
    '음성 메모 / 통역': '音声メモ / 通訳',
    '음성 텍스트 변환': '音声テキスト変換',
    '음성인식': '音声認識',
    '음성인식 설정': '音声認識設定',
    '음성인식 언어 설정': '音声認識言語設定',
    '음성인식 활성화': '音声認識を有効化',
    '음성인식활성화': '音声認識を有効化',
    '음성 인식을 활성화할까요?': '音声認識を有効にしますか？',
    '음성 인식 중 — 자막에 표시됩니다': '音声認識中 - 字幕に表示されます',
    '인식 언어': '認識言語',
    '음성인식을 사용하는 참석자가 없습니다.': '音声認識を使用している参加者はいません。',
    '음성인식을 사용하여 대화를 기록해보세요!': '音声認識を使って会話を記録してみましょう！',
    '님의 발언이 기록됩니다.': 'さんの発言が記録されます。',
    '님의 발언이 더이상 기록되지 않습니다.': 'さんの発言はこれ以上記録されません。',

    '자막/번역': '字幕/翻訳',
    '자막/번역설정': '字幕/翻訳設定',
    '자막/번역 언어': '字幕/翻訳言語',
    '자막/번역언어': '字幕/翻訳言語',
    '자막 표시': '字幕表示',
    '자막 표시 불가': '字幕表示不可',
    '자막 히스토리': '字幕履歴',
    '자막 글꼴 크기': '字幕フォントサイズ',
    '화면에 자막을 표시합니다.': '画面に字幕を表示します。',
    '화면에 자막을 표시하지 않습니다.': '画面に字幕を表示しません。',
    '화면에 번역을 표시합니다.': '画面に翻訳を表示します。',
    '화면에 번역을 표시하지 않습니다.': '画面に翻訳を表示しません。',
    '자막을 보려면 본인 또는 다른 참석자가\n음성 인식을 활성화해야 합니다.': '字幕を見るには、本人または他の参加者が\n音声認識を有効にする必要があります。',
    '내 음성 인식이 꺼져있어 다른 참석자에게는\n내 발언이 자막으로 보이지 않습니다.': '自分の音声認識がオフのため、他の参加者には\n自分の発言が字幕として表示されません。',
    '음성인식을 설정한 참여자들의 발언을': '音声認識を設定した参加者の発言を',
    '자막으로 제공합니다.': '字幕として提供します。',
    '번역 자막': '翻訳字幕',
    '발언 내용을 원하는 언어로': '発言内容を希望する言語に',
    '실시간 번역하여 자막으로 제공합니다.': 'リアルタイム翻訳して字幕で提供します。',
    '실시간 자막이 시작되었습니다.': 'リアルタイム字幕が開始されました。',
    '실시간 자막이 종료되었습니다.': 'リアルタイム字幕が終了しました。',
    '실시간 번역이 시작되었습니다.': 'リアルタイム翻訳が開始されました。',
    '실시간 번역이 종료되었습니다.': 'リアルタイム翻訳が終了しました。',
    'Credit이 모두 소진되어 번역이 중지되었습니다.': 'Creditをすべて使用したため、翻訳が停止されました。',
    'Credit이 부족하여 번역 기능을 사용할 수 없습니다.': 'Creditが不足しているため、翻訳機能を使用できません。',
    '크레딧이 부족합니다.': 'クレジットが不足しています。',
    '크레딧 조회에 실패했습니다. 다시 시도해주세요.': 'クレジットの照会に失敗しました。もう一度お試しください。',
    '추가 크레딧 구매하기': '追加クレジットを購入',
    '크레딧 추가 구매는 회사 관리자에게 문의해주세요.': '追加クレジットの購入は会社管理者にお問い合わせください。',
    '번역회의': '翻訳会議',
    '우리회사 크레딧 사용': '自社クレジットを使用',
    '각 회사의 크레딧 사용': '各社のクレジットを使用',
    '외부 참석자들도 회사 크레딧으로 번역 사용을 허용합니다.': '外部参加者にも会社クレジットでの翻訳利用を許可します。',
    '외부 참석자들은 각 회사의 크레딧으로 번역을 사용합니다.': '外部参加者は各社のクレジットで翻訳を使用します。',
    '크레딧을 사용하여 실시간 번역을 제공합니다. 크레딧이 부족할 경우 기능이 제한될 수 있습니다.': 'クレジットを使用してリアルタイム翻訳を提供します。クレジットが不足すると機能が制限される場合があります。',
    '*자막/번역 기능은 음성인식을 설정한 참여자들의 발언에만': '*字幕/翻訳機能は音声認識を設定した参加者の発言にのみ',
    '기능을 제공하며 실시간 번역은 Credit이 차감됩니다.': '提供され、リアルタイム翻訳ではCreditが差し引かれます。',

    '마이크': 'マイク',
    '카메라': 'カメラ',
    '스피커': 'スピーカー',
    '오디오': 'オーディオ',
    '비디오': 'ビデオ',
    '마이크 선택': 'マイクを選択',
    '카메라 선택': 'カメラを選択',
    '스피커 선택': 'スピーカーを選択',
    '마이크 끄기': 'マイクをオフ',
    '마이크 켜기': 'マイクをオン',
    '카메라 끄기': 'カメラをオフ',
    '카메라 켜기': 'カメラをオン',
    '마이크 켜기 요청': 'マイクオンをリクエスト',
    '카메라 켜기 요청': 'カメラオンをリクエスト',
    '마이크 켜기 요청을 보냈습니다.': 'マイクオンのリクエストを送信しました。',
    '카메라 켜기 요청을 보냈습니다.': 'カメラオンのリクエストを送信しました。',
    '스피커를 선택하세요': 'スピーカーを選択してください',
    '마이크를 선택하세요': 'マイクを選択してください',
    '카메라를 선택하세요': 'カメラを選択してください',
    '사용 가능한 스피커 없음': '利用可能なスピーカーなし',
    '사용 가능한 마이크 없음': '利用可能なマイクなし',
    '사용 가능한 카메라 없음': '利用可能なカメラなし',
    '카메라가 없거나 선택되지 않았습니다.': 'カメラがないか選択されていません。',
    '디바이스 없음': 'デバイスなし',
    '스피커 테스트': 'スピーカーテスト',
    '영상 설정': '映像設定',
    '거울 모드(좌우반전)': 'ミラーモード(左右反転)',
    '좌우반전': '左右反転',
    '좌우 반전': '左右反転',
    '회전': '回転',
    '스페이스바를 누르고있는동안': 'スペースキーを押している間',
    '마이크가 켜집니다.': 'マイクがオンになります。',
    'Space키를 길게 눌러 내 음소거를 일시적으로 해제': 'Spaceキーを長押しして自分のミュートを一時的に解除',
    '회의에 참가할 때 내 마이크 음소거': '会議参加時に自分のマイクをミュート',
    '마이크 또는 카메라 권한을 허용해주세요.': 'マイクまたはカメラの権限を許可してください。',
    '마이크 및 카메라 권한이 필요합니다.': 'マイクとカメラの権限が必要です。',
    '브라우저 설정(상단 주소 표시줄 왼쪽의 아이콘)에서': 'ブラウザ設定(上部アドレスバー左のアイコン)で',
    '마스터가 마이크 사용을 요청하였습니다.': 'マスターがマイクの使用をリクエストしました。',
    '마스터가 카메라 사용을 요청하였습니다.': 'マスターがカメラの使用をリクエストしました。',
    '마스터에 의해 마이크가 꺼졌습니다.': 'マスターによりマイクがオフになりました。',
    '마스터에 의해 카메라가 꺼졌습니다.': 'マスターによりカメラがオフになりました。',
    '마스터에 의해 회의에서 내보내졌습니다.': 'マスターにより会議から退出させられました。',
    '모두 마이크 끄기': '全員のマイクをオフ',
    '모두 마이크 켜기 요청': '全員にマイクオンをリクエスト',
    '모두 카메라 끄기': '全員のカメラをオフ',
    '모두 카메라 켜기 요청': '全員にカメラオンをリクエスト',
    '모든 참석자의 마이크가 이미 꺼져있습니다.': '全参加者のマイクはすでにオフです。',
    '모든 참석자의 마이크를 껐습니다.': '全参加者のマイクをオフにしました。',
    '모든 참석자의 카메라가 이미 꺼져있습니다.': '全参加者のカメラはすでにオフです。',
    '모든 참석자의 카메라를 껐습니다.': '全参加者のカメラをオフにしました。',
    '소리 켜기': '音声をオン',
    '음소거': 'ミュート',
    '음소거 해제': 'ミュート解除',

    '화면 공유': '画面共有',
    '화면공유': '画面共有',
    '화면 공유 중': '画面共有中',
    '화면 공유중': '画面共有中',
    '화면 공유 중지': '画面共有を停止',
    '공유': '共有',
    '공유 중지': '共有停止',
    '공유취소': '共有キャンセル',
    '공유취소 버튼을 눌러주세요': '共有キャンセルボタンを押してください。',
    '다른 참여자가 이미 공유 중입니다.': '他の参加者がすでに共有中です。',
    '다른 사용자의 공유가 끝난 후': '他のユーザーの共有が終了した後、',
    '이미 문서공유가 진행중입니다.': '文書共有がすでに進行中です。',
    '이미 스케치모드가 진행중입니다.': 'スケッチモードがすでに進行中です。',
    '이미 문서공유 또는 스케치가 진행중입니다.': '文書共有またはスケッチがすでに進行中です。',
    '화면·문서 공유 중': '画面・文書共有中',
    '나의 공유 화면': '自分の共有画面',
    '화면 고정': '画面を固定',
    '화면 고정 해제': '画面固定を解除',
    '고정': '固定',
    '고정 해제': '固定解除',
    '고정했습니다.': '固定しました。',
    '고정 해제했습니다.': '固定を解除しました。',
    '나에게만 화면 고정': '自分にだけ画面を固定',
    '모두에게 화면 고정': '全員に画面を固定',
    '마스터가 고정한 화면입니다.': 'マスターが固定した画面です。',
    '마스터가 화면을 고정하여 변경할 수 없습니다.': 'マスターが画面を固定しているため変更できません。',
    '고정된 화면을 해제한 후 다시 시도해주세요.': '固定された画面を解除してからもう一度お試しください。',
    '고정된 화면으로 돌아가기': '固定画面に戻る',
    '화면은 최대 ${...}개까지 고정가능합니다.': '画面は最大${...}個まで固定できます。',
    '화면이 고정되었습니다. ${...}/${...}': '画面を固定しました。${...}/${...}',
    '화면 고정이 해제되었습니다. ${...}/${...}': '画面固定を解除しました。${...}/${...}',
    '일반화면': '通常画面',
    '분할화면': '分割画面',
    '그리드뷰': 'グリッドビュー',
    '사이드뷰': 'サイドビュー',
    '발표자뷰': '発表者ビュー',
    '자동정렬': '自動整列',
    '자동 정렬': '自動整列',
    '발언자 우선 정렬': '発言者優先整列',
    '참여자명 정렬': '参加者名で整列',
    '보기': '表示',
    '정렬 기준': '整列基準',
    '화면 자동 전환': '画面自動切替',
    '연결 품질:': '接続品質:',
    '수신 해상도:': '受信解像度:',
    '네트워크 상태 :': 'ネットワーク状態:',
    '좋음': '良好',
    '보통': '普通',
    '나쁨': '悪い',
    '네트워크가 불안정하여 연결이 종료되었습니다.': 'ネットワークが不安定なため接続が終了しました。',
    '네트워크 상태 확인 후 회의에 다시 참석해 주세요.': 'ネットワーク状態を確認してから会議に再参加してください。',
    '네트워크 상태가 불안정합니다. 화질이나 음성이 일시적으로 끊길 수 있습니다.': 'ネットワーク状態が不安定です。映像や音声が一時的に途切れる場合があります。',
    '네트워크 상태가 좋지 않습니다. Wi-Fi 또는 유선 연결 상태를 확인해 주세요.': 'ネットワーク状態が良くありません。Wi-Fiまたは有線接続の状態を確認してください。',
    '회의 연결이 불안정합니다. 네트워크 상태를 확인해 주세요.': '会議の接続が不安定です。ネットワーク状態を確認してください。',
    '마이크에서 큰 소음이나 하울링이 감지됩니다. 스피커 볼륨을 낮추거나 이어폰을 사용해 주세요.': 'マイクから大きなノイズまたはハウリングが検出されています。スピーカー音量を下げるかイヤホンを使用してください。',

    '문서 공유': '文書共有',
    '문서공유': '文書共有',
    '문서 공유 중': '文書共有中',
    '문서공유 모드': '文書共有モード',
    '문서 공유 종료': '文書共有を終了',
    '문서공유 종료': '文書共有を終了',
    '문서공유를 종료하시겠습니까?': '文書共有を終了しますか？',
    '문서 공유 중 오류가 발생했습니다.': '文書共有中にエラーが発生しました。',
    '문서 공유에 실패했습니다. 지원하지 않는 파일 형식이거나\n용량이 초과되었을 수 있습니다.': '文書共有に失敗しました。対応していないファイル形式、または\n容量超過の可能性があります。',
    '문서 이전': '前の文書',
    '문서 다음': '次の文書',
    '문서리스트 닫기': '文書リストを閉じる',
    '문서를 변환 중입니다...': '文書を変換中...',
    '문서를 불러오는 중입니다...': '文書を読み込み中...',
    '문서를 미리볼 수 없습니다.': '文書をプレビューできません。',
    '문서 변환에 실패했습니다. 잠시 후 다시 시도해주세요.': '文書変換に失敗しました。しばらくしてからもう一度お試しください。',
    '문서 변환 중 오류가 발생했습니다.': '文書変換中にエラーが発生しました。',
    '문서 변환에 실패하였습니다.\n잠시 후 다시 시도해 주세요.': '文書変換に失敗しました。\nしばらくしてからもう一度お試しください。',
    '파일 선택': 'ファイル選択',
    '파일선택': 'ファイル選択',
    '파일 목록을 불러올 수 없습니다.': 'ファイル一覧を読み込めません。',
    '파일 목록이 업데이트되었습니다. 총 ': 'ファイル一覧が更新されました。合計 ',
    '파일 목록이 업데이트되었습니다. 총': 'ファイル一覧が更新されました。合計',
    '개의 파일이 있습니다.': ' 個のファイルがあります。',
    '파일 변환 중입니다. 잠시 후 다시 시도해주세요.': 'ファイルを変換中です。しばらくしてからもう一度お試しください。',
    '파일이 저장되었습니다.': 'ファイルが保存されました。',
    '파일을 다운로드하고 있습니다.(': 'ファイルをダウンロード中です。(',
    '파일명': 'ファイル名',
    '파일뷰어': 'ファイルビューア',
    '페이지를 불러올 수 없습니다.': 'ページを読み込めません。',
    '이미지를 미리볼 수 없습니다.': '画像をプレビューできません。',
    '이미지에 문제가 발생하여 미리볼 수 없습니다.': '画像に問題が発生したためプレビューできません。',
    '너비 맞춤': '幅に合わせる',
    '높이 맞춤': '高さに合わせる',
    '실제 사이즈': '実際のサイズ',
    '작성 날짜': '作成日',
    '업로드 날짜': 'アップロード日',
    '업로드한 날짜': 'アップロード日',
    '수정된 날짜': '修正日',
    '수정한 날짜': '修正日',
    '업로더': 'アップロード者',
    '수정한 사람': '修正者',
    '일반 정보': '一般情報',
    'WE드라이브': 'WE Drive',
    'WE 드라이브': 'WE Drive',
    'WE드라이브 회의자료 등록 실패:': 'WE Drive会議資料の登録に失敗:',
    'WE드라이브에서 파일찾기': 'WE Driveでファイルを探す',
    'WE드라이브 정보를 불러올 수 없습니다.\n로그인 상태를 확인해주세요.': 'WE Drive情報を読み込めません。\nログイン状態を確認してください。',
    '지원하지 않는 파일 형식입니다. (${...})': '対応していないファイル形式です。(${...})',
    '지원 형식: hwp, doc(x), xls(x), ppt(x), bmp, gif, jpg, png, pdf': '対応形式: hwp, doc(x), xls(x), ppt(x), bmp, gif, jpg, png, pdf',
    '공유 파일 용량 초과\n공유 가능한 파일 용량을 초과하였습니다.\n20MB 이하의  파일을 선택해주세요.': '共有ファイルの容量超過\n共有可能な容量を超えました。\n20MB以下のファイルを選択してください。',
    '공유 파일 용량 초과\n공유 가능한 파일 용량을 초과하였습니다.\n20MB 이하의 파일을 선택해주세요.': '共有ファイルの容量超過\n共有可能な容量を超えました。\n20MB以下のファイルを選択してください。',
    '검색어를 입력해주세요.': '検索語を入力してください。',
    '표시할 내용이 없습니다.': '表示する内容がありません。',
    '회의자료': '会議資料',
    '회의자료 등록 실패:': '会議資料の登録に失敗:',
    '회의 자료를 불러오는 중입니다...': '会議資料を読み込み中...',
    '회의 자료를 삭제할까요?': '会議資料を削除しますか？',
    '회의자료 첨부': '会議資料を添付',
    '첨부파일 선택': '添付ファイルを選択',
    '전체선택': 'すべて選択',
    '이전 회의 자료': '前回会議資料',
    '등록된 회의 자료가 없습니다.': '登録された会議資料がありません。',
    '필요한 자료를 업로드하여 다른 참석자와 공유해보세요!': '必要な資料をアップロードして他の参加者と共有しましょう！',
    '삭제된 파일은 복구할 수 없으며\n다른 참석자들에게 더 이상 노출되지 않습니다.': '削除されたファイルは復元できず、\n他の参加者には表示されなくなります。',
    '삭제된 파일은 복구할 수 없으며\n다른 참석자들에게 더 이상 노출되지 않습니다.\n*다른 사람이 첨부한 파일을 제외하고 삭제합니다.': '削除されたファイルは復元できず、\n他の参加者には表示されなくなります。\n*他の人が添付したファイルは削除対象から除外されます。',
    '다운로드가 취소되었습니다.': 'ダウンロードがキャンセルされました。',

    '스케치 모드': 'スケッチモード',
    '스케치 종료': 'スケッチ終了',
    '스케치 공유': 'スケッチ共有',
    '스케치모드 공유 중': 'スケッチモード共有中',
    '스케치 화면을': 'スケッチ画面を',
    '더 넓게 활용 해보세요': 'より広く活用してみましょう',
    '다양한 그리기 도구를 이용해': 'さまざまな描画ツールを使って',
    '화면에 스케치를 할 수 있어요!': '画面にスケッチできます！',
    '스케치 공유 중에도': 'スケッチ共有中でも',
    '다른 참석자들을 확인 할 수 있어요': '他の参加者を確認できます',
    '작성중인 스케치 화면을 캡쳐해보세요!': '作成中のスケッチ画面をキャプチャしてみましょう！',
    '캡쳐된 이미지는 회의기록에서도 확인': 'キャプチャされた画像は会議記録でも確認',
    '할 수 있어요': 'できます',
    '스케치를 종료 하려면': 'スケッチを終了するには',
    '현재 스케치 화면이 캡쳐되었습니다.': '現在のスケッチ画面をキャプチャしました。',
    '스케치 캡쳐가 저장되었습니다.': 'スケッチキャプチャを保存しました。',
    '캡쳐 실패:': 'キャプチャ失敗:',
    '캡쳐': 'キャプチャ',
    '스케치 화면을 ‘캡쳐’ 해서 저장해 보세요!': 'スケッチ画面を「キャプチャ」して保存してみましょう！',
    '회의기록에 저장할 스케치 화면을 ‘캡쳐’ 해보세요!': '会議記録に保存するスケッチ画面を「キャプチャ」してみましょう！',
    '화이트보드': 'ホワイトボード',
    '회의 스케치': '会議スケッチ',
    '공동 편집': '共同編集',
    '공동 편집이 종료되었어요.': '共同編集が終了しました。',
    '공동 편집이 활성화 되었어요. 함께 스케치해보세요!': '共同編集が有効になりました。一緒にスケッチしましょう！',
    '권한 변경에 실패했습니다. 다시 시도해 주세요.': '権限変更に失敗しました。もう一度お試しください。',
    '편집 권한': '編集権限',
    '공유자외에 다른 참석자는 보기만 가능합니다.': '共有者以外の参加者は閲覧のみ可能です。',
    '공유모드 선택': '共有モード選択',
    '뷰어': 'ビューア',
    '사이드바 가리기': 'サイドバーを隠す',
    '썸네일': 'サムネイル',
    '크게보기': '拡大表示',
    '눈금': 'グリッド',
    '눈금 없음': 'グリッドなし',
    '배경색': '背景色',
    '그리기': '描画',
    '펜': 'ペン',
    '펜툴': 'ペンツール',
    '지우개': '消しゴム',
    '도형': '図形',
    '도형 선택': '図形選択',
    '네모': '四角形',
    '원': '円',
    '마름모': 'ひし形',
    '다이아몬드': 'ひし形',
    '선': '線',
    '화살표': '矢印',
    '텍스트': 'テキスト',
    '실행취소': '元に戻す',
    '재실행': 'やり直し',
    '다시실행': 'やり直し',
    '이전으로 복귀': '前に戻る',
    '축소': '縮小',
    '확대': '拡大',
    '전체 지우기': 'すべて消去',
    '흰색': '白',
    '회색': '灰色',
    '파란색': '青',
    '노란색': '黄',
    '격자 1': 'グリッド1',
    '격자 2': 'グリッド2',
    '검정': '黒',
    '빨강': '赤',
    '파랑': '青',
    '초록': '緑',
    '노랑': '黄',
    '보라': '紫',

    '배경': '背景',
    '가상배경': 'バーチャル背景',
    '가상 배경': 'バーチャル背景',
    '가상배경 설정': 'バーチャル背景設定',
    '화상회의 배경설정': 'ビデオ会議背景設定',
    '배경 및 효과를 설정해주세요.': '背景と効果を設定してください。',
    '배경 선택': '背景を選択',
    '배경 이미지': '背景画像',
    '배경없음': '背景なし',
    '효과 및 블러 없음': '効果・ぼかしなし',
    '흐리게': 'ぼかし',
    '블러 30%': 'ぼかし30%',
    '블러 80%': 'ぼかし80%',
    '이미지 추가': '画像追加',
    '사용자 지정 이미지': 'カスタム画像',
    '사용자 설정 시뮬레이션 화면': 'ユーザー設定シミュレーション画面',
    '은은한': 'やわらかい',
    '은은한 배경': 'やわらかい背景',
    '스터디카페': 'スタディカフェ',
    '카페': 'カフェ',
    '사무실': 'オフィス',
    '오피스': 'オフィス',
    '석양': '夕焼け',
    '노을': '夕焼け',
    '해변': 'ビーチ',
    '시티뷰': 'シティビュー',
    '도시': '都市',
    '기하학적인': '幾何学的',
    '기하학': '幾何学',
    '현대적인': 'モダン',
    '모던': 'モダン',
    '오로라': 'オーロラ',
    '아바타 1': 'アバター1',
    '아바타 2': 'アバター2',
    '아바타 3': 'アバター3',
    '5MB이하의 이미지 형식만 가능합니다.': '5MB以下の画像形式のみ使用できます。',
    '최대 ${...}개까지 추가가 가능합니다.': '最大${...}個まで追加できます。',
    '추가하기': '追加する',
    '다음에': '後で',

    '발언권 요청': '発言権リクエスト',
    '발언권 요청 (': '発言権リクエスト (',
    '발언권 요청 중입니다...': '発言権をリクエスト中です...',
    '발언권을 요청하였습니다.': '発言権をリクエストしました。',
    '발언권이 승인되었습니다.': '発言権が承認されました。',
    '발언권 모드': '発言権モード',
    '발언권 모드 해제': '発言権モード解除',
    '발언권 모드가 활성화되었습니다.': '発言権モードが有効になりました。',
    '발언 요청': '発言をリクエスト',
    '발언 종료': '発言終了',
    '요청 취소': 'リクエスト取消',
    '전체 수락': 'すべて承諾',
    '전체 거부': 'すべて拒否',
    '전체 거절': 'すべて拒否',
    '전체 승인': 'すべて承認',
    '수락': '承諾',
    '거절': '拒否',
    '거부': '拒否',
    '승인': '承認',

    '리액션': 'リアクション',
    '이모티콘': '絵文字',
    '캐릭터': 'キャラクター',
    '최근': '最近',
    '좋아요': 'いいね',
    '박수': '拍手',
    '하트눈': 'ハート目',
    '불꽃': '炎',
    '축하': 'お祝い',
    '하트': 'ハート',
    '100점': '100点',
    '위대리': 'ウィ代理',
    '고과장': 'コ課長',
    '하사원': 'ハ社員',
    '다하쥐': 'ダハジ',
    '퉁카': 'トゥンカ',

    '영상녹화': '映像録画',
    '회의녹화': '会議録画',
    '회의 녹화': '会議録画',
    '녹화 중지': '録画停止',
    '회의를 기록하고 저장할 수 있습니다.': '会議を記録して保存できます。',
    '녹화된 영상은 회의 기록에서 조회가능합니다.': '録画された映像は会議記録で確認できます。',

    '현재 상태': '現在の状態',
    '현재 뷰': '現在のビュー',
    '참여자 수': '参加者数',
    '(원격': '(リモート',
    '+ 본인)': '+ 本人)',
    '적용 정책': '適用ポリシー',
    '오버라이드': 'オーバーライド',
    '그리드뷰 정책 편집': 'グリッドビューポリシー編集',
    '구간 추가': '区間追加',
    '조건': '条件',
    '해상도': '解像度',
    '메인': 'メイン',
    '서브': 'サブ',
    '뷰 모드': 'ビューモード',
    '대상': '対象',
    '기본값 복원': '初期値に戻す',
    '자동 (정책 기본값)': '自動(ポリシー既定値)',
    '그리드 뷰에서 한 화면에 표시할 최대 사용자 수를 선택하세요': 'グリッドビューで1画面に表示する最大ユーザー数を選択してください。',
    '참여자 수 구간별 수신 해상도를 설정합니다. 구간은 오름차순으로 자동 정렬됩니다.': '参加者数区間別の受信解像度を設定します。区間は昇順で自動整列されます。',
    '발표자·사이드뷰의 수신 해상도를 강제로 고정합니다. &quot;자동&quot;은 기본 정책 값을 따릅니다.': '発表者・サイドビューの受信解像度を強制固定します。&quot;自動&quot;は既定ポリシー値に従います。',
    '발표자/사이드뷰 해상도 오버라이드': '発表者/サイドビュー解像度オーバーライド',

    '검색어 입력': '検索語入力',
    '두 글자 이상 입력해주세요.': '2文字以上入力してください。',
    '내용입력': '内容入力',
    '키워드 추가': 'キーワード追加',
    '키워드를 입력하고 Enter를 눌러주세요.': 'キーワードを入力してEnterを押してください。',
    '선택안함': '選択なし',
    '모든 참석자에게 이전 회의 내용 공유': 'すべての参加者に前回会議の内容を共有',
    '지난 회의 참석자에게만 이전 회의 내용 공유': '前回会議の参加者にのみ前回会議の内容を共有',
    '암호가 있는 사용자만 회의에 참가할 수 있습니다.': 'パスワードを持つユーザーのみ会議に参加できます。',
    '발표자 자동전환': '発表者自動切替',

    '화상회의에서 사용할 이름을 설정해 주세요.': 'ビデオ会議で使用する名前を設定してください。',
    '참석자 명': '参加者名',
    '사용자의 음성을 텍스트로 변환하여': 'ユーザーの音声をテキストに変換して',
    '자막과 번역을 제공하고, 회의 기록을 확인할 수 있습니다.': '字幕と翻訳を提供し、会議記録を確認できます。',
    '사용자의 음성을 텍스트로 변환하여 자막과 번역을 제공하고, 회의': 'ユーザーの音声をテキストに変換して字幕と翻訳を提供し、会議',
    '기록을 확인할 수 있습니다.': '記録を確認できます。',
    '*화상회의 중 음성인식은 실시간 분석 및 대화기록에만 사용되며 회의 종료 후  음성 데이터는 저장되지 않습니다.': '*ビデオ会議中の音声認識はリアルタイム分析および会話履歴にのみ使用され、会議終了後に音声データは保存されません。',
    '*화상회의 중 음성인식은 실시간 분석 및 대화기록에만 사용되며 회의 종료 후 음성 데이터는 저장되지 않습니다.': '*ビデオ会議中の音声認識はリアルタイム分析および会話履歴にのみ使用され、会議終了後に音声データは保存されません。',
    'ESC 키를 누르면 전체화면 모드가 종료됩니다.': 'ESCキーを押すと全画面モードが終了します。',
    '화상회의 잠시 후 시작': 'ビデオ会議はまもなく開始',
    '화상회의 시작 ${...} 전': 'ビデオ会議開始${...}前',
    '이 회의는': 'この会議は',
    '에 시작 예정입니다.': 'に開始予定です。',
    '화상회의가 시작됩니다.': 'ビデオ会議が開始されます。',
    '약 ${...}분': '約${...}分',
    '약 ${...}시간': '約${...}時間',
    '약 ${...}시간 ${...}분': '約${...}時間${...}分',

    '월': '月',
    '화': '火',
    '수': '水',
    '목': '木',
    '금': '金',
    '토': '土',
    '일': '日',
    '월요일': '月曜日',
    '화요일': '火曜日',
    '수요일': '水曜日',
    '목요일': '木曜日',
    '금요일': '金曜日',
    '토요일': '土曜日',
    '일요일': '日曜日',
    '오전': '午前',
    '오후': '午後',

    '필요한 데이터 및 보안 문제 검토': '必要なデータおよびセキュリティ問題の確認',
    '현재 사용중인 업무 플랫폼과 AI 연동 가능 여부': '現在使用中の業務プラットフォームとAI連携可否',
    '기대효과 및 실무 적용 가능성 분석': '期待効果および実務適用可能性の分析',
    '업무 효율성 향상 및 반복 작업 감소': '業務効率向上および反復作業削減',
    '1. 주요 논의 내용': '1. 主な議論内容',
    '2. 결정 사항 및 해야할 일': '2. 決定事項および対応事項',
    'AI 기반 업무 자동화 방안': 'AIベースの業務自動化案',
    'AI 챗봇을 활용한 사내정보 검색 기능 추가': 'AIチャットボットを活用した社内情報検索機能追加',
    '고객 대응 AI 시스템 도입 검토 (FAQ 자동응답, 상담 지원)': '顧客対応AIシステム導入検討(FAQ自動応答、相談支援)',
    '고객 응대 속도 개선 및 직원 업무 부담 감소': '顧客対応速度改善および従業員業務負担軽減',
    '기술적 검토 필요 사항': '技術的検討が必要な事項',
    '기술검토 : 개발팀에서 AI 연동 가능성 검토 (담당 : 홍길동)': '技術検討: 開発チームでAI連携可能性を検討(担当: ホン・ギルドン)',
    '문서 자동 요약 및 일정 관리 기능 도입': '文書自動要約および日程管理機能の導入',
    'ONE AI 더 알아보기': 'ONE AIについて詳しく見る',

    '@jitsi/excalidraw 패키지가 설치되지 않았습니다.': '@jitsi/excalidrawパッケージがインストールされていません。',
    'state 값을 찾을 수 없습니다.': 'state値が見つかりません。',
    'lib-jitsi-meet 라이브러리를 불러올 수 없습니다.': 'lib-jitsi-meetライブラリを読み込めません。',
    'LUXDialog: DialogProvider가 마운트되지 않았습니다.': 'LUXDialog: DialogProviderがマウントされていません。',
  },
};
